import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { StoreRegistryHelper } from '../shared/helpers/store-registry-helper';
import { rootReducer } from './root-reducer';
import { rootSagas } from './root-saga';

const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware];

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, composeEnhancers(applyMiddleware(...middlewares)));
StoreRegistryHelper.register(store);
if (process.env.NODE_ENV !== 'test') {
    sagaMiddleware.run(rootSagas);
}
export { store };
